// Pure helpers for the weather chip/panel. AQI colors follow OWM's 1-5 scale.
const AQI = {
  1: { labelKey: 'weather.aqiGood', color: '#10b981' },
  2: { labelKey: 'weather.aqiFair', color: '#84cc16' },
  3: { labelKey: 'weather.aqiModerate', color: '#f59e0b' },
  4: { labelKey: 'weather.aqiPoor', color: '#f97316' },
  5: { labelKey: 'weather.aqiVeryPoor', color: '#dc2626' },
};

export function aqiSeverity(index) {
  return AQI[index] || { labelKey: 'weather.aqiUnknown', color: '#94a3b8' };
}

const ICON_EMOJI = {
  '01d': '☀️', '01n': '🌙',
  '02d': '⛅', '02n': '⛅', '03d': '⛅', '03n': '⛅',
  '04d': '☁️', '04n': '☁️',
  '09d': '🌧️', '09n': '🌧️', '10d': '🌧️', '10n': '🌧️',
  '11d': '⛈️', '11n': '⛈️',
  '13d': '❄️', '13n': '❄️',
  '50d': '🌫️', '50n': '🌫️',
};

export function iconEmoji(icon) {
  return ICON_EMOJI[icon] || '🌡️';
}

// `s.at` is a UTC ISO-Z instant (server-normalized, see weather-client.ts).
// Group by the VIEWER's LOCAL calendar date, not the UTC date slice — a slot
// at 21:30 UTC is already "tomorrow" in Baghdad (UTC+3), and grouping on the
// raw UTC string would put it in the wrong day bucket for local users.
export function groupForecastByDay(slots) {
  const byDay = new Map();
  for (const s of Array.isArray(slots) ? slots : []) {
    if (!s?.at) continue;
    const d = new Date(s.at);
    if (Number.isNaN(d.getTime())) continue;
    const day = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    if (!byDay.has(day)) byDay.set(day, []);
    byDay.get(day).push(s);
  }
  return [...byDay.entries()].map(([day, daySlots]) => {
    const temps = daySlots.map((s) => s.tempC).filter((t) => typeof t === 'number');
    // icon from the slot closest to local midday
    const midday = daySlots.reduce((best, s) => {
      const hour = new Date(s.at).getHours();
      const bestHour = new Date(best.at).getHours();
      return Math.abs(hour - 12) < Math.abs(bestHour - 12) ? s : best;
    }, daySlots[0]);
    return {
      day,
      minC: temps.length ? Math.min(...temps) : null,
      maxC: temps.length ? Math.max(...temps) : null,
      icon: midday.icon,
      slots: daySlots,
    };
  });
}
